var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#155C8F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_2260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2597 27.3332H10.9854V10.2662H24.2597V27.3332Z",
    fill: "#E8EFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1982 12.1625H26.4726V29.5456H13.1982V12.1625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_2260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2275,
    height: 20.2275,
    fill: "white",
    transform: "translate(8.77246 9.31804)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/ScanIcon.505396e16c90d6b06d9c3520a1fa7b75.svg";
export { ForwardRef as ReactComponent };